import { render, staticRenderFns } from "./ConfirmPayment.vue?vue&type=template&id=94c267c4&scoped=true"
import script from "./ConfirmPayment.vue?vue&type=script&lang=js"
export * from "./ConfirmPayment.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPayment.vue?vue&type=style&index=0&id=94c267c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c267c4",
  null
  
)

export default component.exports